// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr.spliter[data-v-11e4051b] {\n  border: 1px solid #dbdbdb;\n}\n.custom-label[data-v-11e4051b] {\n  vertical-align: middle;\n  font-size: 14px;\n  color: #606266;\n  line-height: 40px;\n  padding: 0 12px 0 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  font-weight: 700;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
